// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2bAAM","header":"Messages_header__yonTi"};